import { render, staticRenderFns } from "./SkeletonPeopleTourRewardsProduct.vue?vue&type=template&id=12084aea&scoped=true"
import script from "./SkeletonPeopleTourRewardsProduct.vue?vue&type=script&lang=js"
export * from "./SkeletonPeopleTourRewardsProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12084aea",
  null
  
)

export default component.exports